export function dateFormatter(date: number): string {
  return new Date(date).toLocaleDateString('default', {
    day: '2-digit',
    month: '2-digit',
  });
}
